// https://github.com/cornerstonejs/cornerstone3D-beta/blob/main/utils/demo/helpers/initCornerstoneWADOImageLoader.js

import dicomParser from "dicom-parser";
import * as cornerstone from "@cornerstonejs/core";
import dicomImageLoader from "@cornerstonejs/dicom-image-loader";

// export default function initCornerstoneWADOImageLoader() {
//   dicomImageLoader.init({
//     maxWebWorkers:
//       typeof navigator !== "undefined" && navigator.hardwareConcurrency
//         ? Math.max(1, Math.floor(navigator.hardwareConcurrency / 2))
//         : 1,
//   });
//   dicomImageLoader.external.cornerstone = cornerstone;
//   dicomImageLoader.external.dicomParser = dicomParser;
//   dicomImageLoader.configure({
//     retryAfterTimeoutDelay: 100,
//     useWebWorkers: true,
//     decodeConfig: {
//       convertFloatPixelDataToInt: false,
//       use16BitDataType: preferSizeOverAccuracy ?? false,
//     },
//     beforeSend: (xhr: XMLHttpRequest) => {
//       xhr.withCredentials = true;
//     },
//   });

//   cornerstoneWADOImageLoader.webWorkerManager.initialize({
//     maxWebWorkers: navigator.hardwareConcurrency - 1 || 1,
//     startWebWorkersOnDemand: true,
//     taskConfiguration: {
//       decodeTask: {
//         initializeCodecsOnStartup: false,
//         usePDFJS: false,
//         strict: false,
//       },
//     },
//   });
// }

export default function initCornerstoneWADOImageLoader() {
  dicomImageLoader.init({
    maxWebWorkers:
      typeof navigator !== "undefined" && navigator.hardwareConcurrency
        ? Math.max(1, Math.floor(navigator.hardwareConcurrency / 2))
        : 1,

    beforeSend: async (
      xhr,
      imageId,
      defaultHeaders,
      params
    ): Promise<Record<string, string> | void> => {
      xhr.withCredentials = true;
    },
  });
}
